import {useState, useEffect} from 'react';
import {FormTypeRep} from "./FormTypeRep"
import {CreatedQuestion} from "./CreatedQuestion"
import {Aff_question} from "./Aff_question"
//import {MathJax, MathJaxContext } from "better-react-mathjax";
import {MathJaxContext } from "better-react-mathjax";

export function Creer ({auth, liste_activites_all}) {
  //console.log(auth)

  const [msg, setMsg] = useState('')
  const [question, setQuestion] = useState({
    chapitre: '',
    titre: '',
    notion:auth.chapitre+(auth.titre ? '/'+auth.titre : '' ),
    niveau:'',
    etoile: 1, 
    enonce: '', 
    selection:{},
    search:'',
    img: '', 
    type_rep: '', 
    reps:['Réponse 1 (la bonne)', 'Réponse 2'],
    nb_bonnes_rep:'',
    field:'',
    activTex:false,
    TexRand:false,
    TexRandMin:'2',
    TexRandMax:'9',
    imageLoaded:false,
    modif_question:false,
    id:'',
  })

  const [formData, setFormData] = useState(new FormData())
  const [created_question, setCreated_question] = useState([])
	
  function import_created (niveau, chapitre, titre) {
    //console.log(niveau, chapitre, titre)
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'recup_created', niveau, chapitre, titre})
    })
    .then(response => response.json())
    .then(data => {
      //console.log('recup_created', data)
      setCreated_question(data)
    })
    .catch(err => console.log(err))
  }

  const handleChange = (e) => {
    let name = e.target.name
    let val = e.target.value

    if(e.target.id === 'reps') {
      let numRep = e.target.name.substr(-1)*1
      let repscopy = [...question.reps]
      repscopy[numRep-1] = e.target.value ? e.target.value : 'Réponse '+numRep

      name = 'reps'
      val = repscopy
    }
    if(name === 'nb_bonnes_rep' && !['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'].includes(val)) {
      e.target.value = ''
      val=''
    }
    
    setQuestion({...question, [name]:val})
  }

  const handleClick = (event) => {
    if(!document.querySelector('#file').value && !question.imageLoaded){return}
    let uniqId = 'user_'+auth.prenom+'_'+auth.nom+'_'+question.niveau+'_'+('azertyuiopmlkjhgfdsqwxcvbn123456789'.repeat(10).split('').sort(() => Math.random() - 0.5).join('').slice(0,10))+'_'
    //let val = true

    var file = document.getElementById('file').files[0]
    
    if (!question.imageLoaded && !['png', 'jpe', 'svg', 'gif'].includes(file.type.slice(6,9))){
      setMsg('<div class="alert danger fadeout5"><br>Le format de l\'image n\'est pas accepté.<br>Veuillez utiliser une image valide.<br><br></div>')
      setTimeout(e => {setMsg('')}, 5000)
      return
    }
    if (file?.size > 4000000){
      setMsg('<div class="alert danger fadeout5"><br>La taille de l\'image est trop grande.<br>Veuillez choisir une image de taille inférieure à 4 Mo.<br><br></div>')
      setTimeout(e => {setMsg('')}, 5000)
      return
    }
    if (!question.imageLoaded && file) {
      var reader  = new FileReader()
      reader.onload = function(e)  {
        var image = document.createElement("img");
        image.src = e.target.result;
        image.className = 'center'
        document.querySelector('.enonce').appendChild(image);
      }
      reader.readAsDataURL(file)
      //val = true

      formData.append("image", file, uniqId+file.name.replaceAll(' ', ''))
      setFormData(formData)
      setQuestion({...question, imageLoaded:true, img: '<img class=center src=../user_img/'+uniqId+file.name.replaceAll(' ', '')+'>'})
    }

    if(question.imageLoaded){
      document.querySelector('.enonce img').remove()
      //val = false
      setQuestion({...question, imageLoaded:false, img:''})
      formData?.delete("image")
      setFormData(formData)
    }
  }

  const handleSubmit = (e) => {
    if(!question.enonce.replaceAll(' ', '')){
      setMsg('<div class="alert danger fadeout3"><br>Veuillez compléter votre énoncé.<br><br></div>')
      setTimeout(e => setMsg(''), 3000)
      return
    }
    if(!question.type_rep){
      setMsg('<div class="alert danger fadeout3"><br>Veuillez choisir un type de réponse<br><br></div>')
      setTimeout(e => setMsg(''), 3000)
      return
    }
    let soustitre_tab = []
    let soustitre = ''
    Object.keys(question.selection).forEach(e => soustitre_tab = soustitre_tab.concat(question.selection[e]))
    soustitre = soustitre_tab.sort().join(', ')

    let quest = {
        ...auth,
        action: 'creer_question',
        id:question.id,
        modif_question:question.modif_question,
        chapitre:Object.keys(question.selection).sort().join(', '),
        titre:soustitre + ' ' + '*'.repeat(question.etoile),
        professeur:auth.prenom + '_' + auth.nom,
        niveau:question.niveau,
        notion:question.notion,
        etoile:question.etoile,
        enonce:question.enonce,
        img:question.img,
        qcm:'',
        field:'',
        reponse:'',
        json:JSON.stringify({
          selection:question.selection,
          reps:question.type_rep === 'checkbox' ? [...question.reps, 'checkbox'+question.nb_bonnes_rep] : question.reps,
        })
    }

    let choices = ''
    if(question.type_rep === 'radio'|| question.type_rep === 'checkbox') {
      choices = '["' + question.reps.join('", "') + '"]'
      choices = JSON.stringify(question.reps).replaceAll('\\\\', '\\')
      let qcm_json = JSON.stringify(question.reps)
      quest = {...quest, qcm:choices, reponse:question.reps[0], type:'radio', qcm_json}
    }
    if(question.type_rep === 'checkbox') {
      choices = choices.slice(0, -1) + ',"checkbox'+question.nb_bonnes_rep+'"]'
      quest = {...quest, qcm:choices, type:'checkbox'}
    }
    if(question.type_rep === 'field') {
      let fields = ''
      let fields_rep = '['
      question.field.split('_').forEach((f, k) => {
        fields += (k & 1 ? '<input type=text size='+(f.length+2)+' >' : f)
        fields_rep += k & 1 ? '"'+f.replaceAll('...', '__')+'", ' : ''
      })
      fields_rep = fields_rep.slice(0,-2)
      fields_rep += ']'
      if(question.field.split('_').length === 3){fields_rep = question.field.split('_')[1].replaceAll('...', '__')}
      quest = {...quest, field:fields, reponse:fields_rep, type:'field'}
    }

    //console.log('quest send : ', quest)
    //return 
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(quest)
    })
    .then(response => response.json())
    .then(data => {
      setMsg(data)
      setTimeout(e => setMsg(''), 3000)
      if(question.img) {
        document.querySelector('.enonce img').remove()
        document.querySelector('#file').value=''
      }
      setQuestion({...question, enonce:'', type_rep: '', reps:['Réponse 1 (la bonne)', 'Réponse 2'], field:'', imageLoaded:false, img: '', modif_question:false})
      import_created(question.niveau, question.chapitre, question.titre)
    })
    .catch(err => console.log(err))

    // Images
    if(Array.from(formData.entries()).length){
      fetch("https://maths-au-quotidien.fr/react-automaths/api-image.php", {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
      })
      .catch(err => console.log(err))
    }
  }

  const handleTex = (e) => {
    document.querySelector('textarea[name=enonce]').focus()
    let latex = ''
    
    if(e.target.textContent === 'a/b') {latex = ' \\dfrac {}{} '}
    else if(e.target.textContent === '↵') {latex = '<br>'}
    else if(e.target.textContent === '√') {latex = '\\sqrt{}'}
    else if(e.target.textContent === 'π') {latex = '\\pi'}
    else if(e.target.textContent === '∞') {latex = '\\infty'}
    else if(e.target.textContent === '≠') {latex = '\\ne'}
    else if(e.target.textContent === '≤') {latex = '\\le'}
    else if(e.target.textContent === '≥') {latex = '\\ge'}
    else if(e.target.textContent === '❲') {latex = '\\left('}
    else if(e.target.textContent === '❳') {latex = '\\right)'}
    else if(e.target.textContent === '↦') {latex = '\\mapsto'}
    else if(e.target.textContent === ' ⃗ ') {latex = '\\overrightarrow{AB}'}
    else if('sincostanln'.includes(e.target.textContent)) {latex = '\\'+e.target.textContent}
    else if(e.target.textContent === '∈') {latex = ' \\in '}
    else if(e.target.textContent === 'σ') {latex = ' \\sigma '}
    else if(e.target.textContent === 'α') {latex = ' \\alpha '}
    else {latex =  e.target.textContent}

    if(e.target.title === 'Raccourci LATEX' || e.target.textContent === '↵' || question.enonce.includes('$$')) {
        setQuestion({
        ...question,
        enonce:question.enonce+latex,
        activTex:' \\( \\) '.includes(e.target.textContent) ? !question.activTex : question.activTex
      })
    } else {
        setQuestion({
          ...question,
          enonce:question.enonce+(question.activTex ? latex : ''),
          activTex:' \\( \\) '.includes(e.target.textContent) ? !question.activTex : question.activTex
        })
      }
  }

  const handleClickTitre = (e) => {
    //let name = e.target.attributes.name.nodeValue
    let field = e.target.innerText
    let selection = {}
    let soustitre_tab = []
    //let soustitre = ''

    if(!e.target.title){
      if(question.selection[field] && question.selection[field].length === 0){
        selection = question.selection
        delete selection[field]
      } else {
        selection = {...question.selection, [field]:[]}
      }
    } else {
      const titre = e.target.title.split('/')[0] 

      if(!question.selection[titre]) {
        selection = {...question.selection, [titre]:[field]}
      } else {
        const tab = question.selection[titre]

        if(!tab.includes(field)){
          tab.push(field)
          selection = {...question.selection, [titre]:tab}
        }
        else {
          const index = tab.indexOf(field)
          tab.splice(index, 1)
          if(tab.length === 0){
            selection = question.selection
            delete selection[titre]
          } else {
            selection = {...question.selection, [titre]:tab}
          }
        }
      }
    }
    Object.keys(selection).forEach(e => soustitre_tab = soustitre_tab.concat(selection[e]))
    let titre = soustitre_tab.sort().join(', ')
    let chapitre = Object.keys(selection).sort().join(', ')
    setQuestion({...question, selection, config_supp:'', chapitre, titre:titre.length ? titre : chapitre})
    import_created(question.niveau, chapitre, titre)
    //console.log('titre => ', titre.length ? titre : chapitre)
    //console.log('chapitre => ', chapitre)
  }

  useEffect(()=>{
    if(typeof window?.MathJax !== "undefined"){
      window.MathJax.typeset()
    }
  },[question.enonce, question.reps, question.field, question.chapitre, created_question]); // MathsJax 

  function suppr_created (id) {
    let confirm = window.confirm("Voulez-vous vraiment supprimer cette question ?");
    if (!confirm) {return}
    auth = {...auth, action:'supp_created_question', num_question:id}

    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'supp_created_question'})
    })
    .then(response => response.json())
    .then(data => {
      import_created(question.niveau, question.chapitre, question.titre)
    })
    .catch(err => console.log(err))
  }

  //console.log(question)
  //console.log(auth)
  //console.log(created_question)
  
	return (
    <>
    <div className="content max" >
			<h1>Créer une question</h1>
      <br/><br/>
      <div align="left"><b>▸ Choisir un niveau et au moins un thème :</b></div>
      <br/>
      {
        Object.keys(liste_activites_all).map((niv, k_niv) => <span key={k_niv} className={"btn_param niveau"+(niv === question.niveau ? ' active' : '')} name="niveau" onClick={(e) => setQuestion({...question, search:'', niveau:(question.niveau !== e.target.innerText.trim()) && e.target.innerText.trim(), selection:{}, chapitre:'', titre:'', enonce:'', field:''})}>{niv}</span>)
      }
      {
        question.niveau && <div align={'left'} className={'cadre_notion active'} >
          <input name="search" type="text" className="recherche_rapide" placeholder="Recherche rapide" onChange={handleChange} />
            <br/>
            <div className={'cadre_liste_notion' + (question.search && ' col1')} >
              {Object.keys(liste_activites_all[question.niveau]).map((titre, kt) => 
                <>
                  {titre.toLocaleLowerCase().includes(question.search.toLocaleLowerCase()) && <div key={kt}>
                                      <b name="titre" className={'devoir_titre'+(Object.keys(question.selection).includes(titre) && (question.selection[titre] && question.selection[titre].length === 0) ? ' active' :'')} onClick={handleClickTitre}>{titre}</b>
                                    </div>}
                  {Object.values(liste_activites_all[question.niveau][titre]).map((soustitre,ks) => 
                      (titre.toLocaleLowerCase().includes(question.search.toLocaleLowerCase()) || soustitre.toLocaleLowerCase().includes(question.search.toLocaleLowerCase())) && <div key={ks} title={titre+'/'+soustitre} name="soustitre" className={'devoir_titre'+(question.selection[titre]?.includes(soustitre) ? ' active' :'')} onClick={handleClickTitre} >{ soustitre }
                        </div>
                    )}
                  {(titre.toLocaleLowerCase().includes(question.search.toLocaleLowerCase())) && <br/>}
                </>
              )}
            </div>
            <br/>
          </div>
      }

      {
        //Object.keys(question.selection).length > 0 && <input className="btn" name="devoir_send" type="button" value="Valider" onClick={handleSubmit} />
      }
      <br/>
      {Object.keys(question.selection).length ? 
  	<span style={{display:"flex", alignItems:"center"}} >
  		<div className="login" style={{border:'1px solid', textAlign:'left', padding:'5px 15px', borderRadius:'10px'}}>
      <br/>
  	    	

  	    	Difficulté : {["Niveau 1", "Niveau 2", "Niveau 3"].map((niv, k) => <span 
  				key={k} 
  				name="etoile" 
  				className={'btn_param' + (question.etoile === k+1 ? ' active' : '')} 
  				title={niv} 
  				onClick={() => setQuestion({...question, etoile:k+1})}>
            {'⭐'.repeat(k+1)}
  			</span>)} &emsp;&emsp; Niveau : <span className="btn_param active">{question.niveau}</span> 
          <br/>

  			<textarea name="enonce" onChange={handleChange} value={question.enonce} cols="40" rows="4" placeholder="Enoncé de la question...">
            	</textarea>
        <br/>
        Raccourcis LATEX / html : <a href="https://www.youtube.com/watch?v=TKPal-EKC2M" target="blank" title="Vidéo explicative"  className="logo_youtube"></a><br/>
        <div className="cadre" style={{backgroundColor: "rgba(0, 204, 0, 0.05)"}}>
        <span id="type_rep" className="btn_param" name="equation" onClick={handleTex} title="Raccourci LATEX"> {!question.activTex ? '\\(' : '\\)'} </span>
        {
          ['a/b', '√', 'π', 'cos', 'sin', 'tan', 'ln', '∞'].map(
              (elt, key) => <span id="type_rep" className="btn_param" key={key} name="equation" onClick={handleTex} title="element LATEX">{elt}</span>)
        }
        <br/>
        {
          ['≠', '≤', '≥', '❲', '❳', '∈', '↦', ' ⃗ ', 'α', 'σ', '↵'].map(
              (elt, key) => <span id="type_rep" className="btn_param" key={key} name="equation" onClick={handleTex} title="element LATEX">{elt}</span>)
        }
        </div>
        <br/>

        <FormTypeRep question={question} setQuestion={setQuestion} handleChange={handleChange} />

        <br/><br/>
        <div>
          <b>Ajouter une image :</b> <br/><br/>
          <input name="fichier" type="file" id="file" /><br/>
          <button className="btn center" name="insertImage" style={{width:"35%"}} onClick={handleClick} >{!question.imageLoaded ? 'Ajouter' : 'Supprimer'} l'image</button><br/>
        </div>

        {msg && <div dangerouslySetInnerHTML={{ __html:msg}}></div>}
        <input type="button" className="btn center" value={question.modif_question ? 'Modifier' : 'Créer'} onClick={handleSubmit} />
  		</div>
      
      <MathJaxContext>
      <CreatedQuestion question={question} />
      </MathJaxContext>
  	</span>:''}
    </div>

    {(created_question.length > 0 && question.chapitre) && <div className="content max">
          <h1>Mes questions créées</h1>
          <div align="left">Retrouver, ici, la liste de vos questions créées dans les thèmes sélectionnés.</div>
          {created_question.map((e,key)=> <div key={key} className="page">
              <div className="suppr_serie" style={{right:'10px', top:'10px'}} onClick={()=>suppr_created(e.id)} ></div>
              <h1>{e.chapitre}</h1>
              <h2>{e.titre.replaceAll('*', '⭐')}</h2>
              <MathJaxContext>
              <div className='enonce' dangerouslySetInnerHTML={{ __html:e.enonce.replace('src=../', 'src=https://maths-au-quotidien.fr/')}}></div>
              
              {!e.field ? <div className='reponse qcm'>
                              {e.json ? JSON.parse(e.json).reps.map((elt, k)=>
                                !elt.includes('checkbox') && <label key={k} dangerouslySetInnerHTML={{ __html:elt}}></label>) 
                              : ''}
                            </div> : ''}

              <div className='reponse' dangerouslySetInnerHTML={{ __html:e.field}}></div>
              </MathJaxContext>
              <input type="button" id={e.id} className="btn" value="Modifier" onClick={()=>{
                setCreated_question([])
                let imageLoaded = false
                if(e.enonce.includes('<img')){
                  let img = document.createElement('img')
                  img.setAttribute('src', 'https://maths-au-quotidien.fr/user_img/'+e.enonce.match(/user_img\/(.*?)>/)[1]) 
                  img.className = 'center'
                  document.querySelector('.enonce').appendChild(img)
                  imageLoaded=true
                }
                setQuestion(
                  {
                    ...question,
                    imageLoaded:imageLoaded,
                    chapitre:e.chapitre,
                    titre:e.titre,
                    selection:JSON.parse(e.json).selection,
                    img:e.enonce.includes('<img') ? '<img class=center src=../user_img/'+e.enonce.match(/user_img\/(.*?)>/)[1]+'>' : '',
                    enonce:e.enonce.replace(/<img[^>]+>/, '').replaceAll('&lt;', '<').replaceAll('&gt;', '>'), 
                    field:e.field.replace(/<input[^>]+>/, '_' + e.reponse.replaceAll('__', '...') + '_').replaceAll('&lt;', '<').replaceAll('&gt;', '>'), 
                    etoile:e.titre.split('*').length-1,
                    nb_bonnes_rep:e.qcm.includes('checkbox') ? e.qcm.match(/checkbox(\d+)/)[1] : '',
                    type_rep:e.field ? 'field' : (e.qcm.includes('checkbox') ? 'checkbox' : 'radio'),
                    json:e.json ? JSON.parse(e.json) : '',
                    modif_question:true,
                    id:e.id,
                    reps:e.qcm ? (e.qcm.includes('checkbox') ?
                      JSON.parse(e.json).reps.slice(0,-1)
                      : JSON.parse(e.json).reps
                      ) : ''
                  })
                }
                } />
            </div>
            )}
        </div>}
    </>
	);
}
//<input type="text" name="chapitre" value={question.chapitre} placeholder="Chapitre" title={Object.keys(question.selection).join(', ')}></input><br/>
//<input type="text" name="titre" value={question.titre} placeholder="Titre de la question"></input><br/>